




















import { Component, Prop, Vue } from "vue-property-decorator";
import mhlogo from "../assets/mh-logo.svg";
import { Statement } from "../store/user";
import Getter from "../store/getters";

@Component
export default class PaymentInformation extends Vue {
  @Prop() statement!: Statement;
  private balance_fields = [
    {
      key: "current_balance",
      label: "New Balance",
      transform: this.format_dollars
    },
    {
      key: "total_amount_due",
      label: "Current Payment Due",
      transform: this.format_dollars
    },
    {
      key: "past_due",
      label: "Amount Past Due",
      transform: this.format_dollars
    },
    {
      key: "payment_due_date",
      label: "Payment Due Date",
      transform: (i: any) => i
    }
  ];
  format_dollars(value: number, negative: boolean) {
    let val = (value / 1).toFixed(2);
    val = `$${val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
    if (negative) val = "-" + val;
    return val;
  }
}
